var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-about media",class:_vm.ArticleFormat + ' ' + _vm.pageLoaded},[_c('main-menu'),_vm._v(" "),_c('blog-detail',{attrs:{"data":_vm.ArticleData}}),_vm._v(" "),_c('section-blog',{attrs:{"id":"thought","data":_vm.blogDataA}}),_vm._v(" "),_c('footer-container')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f495d72","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Blog.vue
// module id = null
// module chunks = 